/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  pushbullet:[],
  statement: [],
  popup:false,
  popup2:false,
  popup3:false,
  users:[],
  selected:[],
  statementUser:[],
  userId:{code:'',key:''}
}
